import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export const PRODUCTION = process.env.NODE_ENV !== 'development';
export const DEVELOPMENT = process.env.NODE_ENV === 'development';

export const BASE_WEB_URL = PRODUCTION ? 'https://www.oldschool.gg' : 'http://localhost:3000';
export const BASE_API_URL = PRODUCTION ? 'https://osb.oldschool.gg' : 'http://localhost:3232';

export const CLIENT_ID = PRODUCTION ? '303730326692429825' : '353484579840983042';

export const oauthURL = new URL('https://discordapp.com/oauth2/authorize');
oauthURL.search = new URLSearchParams([
	['redirect_uri', `${BASE_WEB_URL}/oauth/callback`],
	['response_type', 'code'],
	['scope', ['identify'].join(' ')],
	['client_id', CLIENT_ID]
]).toString();
